import styled from "styled-components";

export const ContainerTurnosRecepcionadosLabo = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-top: 10px;
  gap: 12px;
  position: relative;

  .circle {
    fill: none;
    stroke: #3d994a;
    stroke-width: 10;
    stroke-dasharray: 283; /* Circumference of the circle (2 * π * r) */
    stroke-dashoffset: 283;
    animation: drawCicle 1.5s ease-in-out forwards;
  }

  .check {
    fill: none;
    stroke: #3d994a;
    stroke-width: 10;
    stroke-linecap: round;
    stroke-dasharray: 100;
    stroke-dashoffset: 100;
    animation: drawCheck 0.8s ease-in-out forwards;
  }

  @keyframes drawCheck {
    0% {
      stroke-dashoffset: 100;
    }
    100% {
      stroke-dashoffset: 0;
    }
  }
  @keyframes drawCicle {
    0% {
      stroke-dashoffset: 283;
    }
    100% {
      stroke-dashoffset: 0;
    }
  }

  h1 {
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 150%;
    color: var(--color-latex10);
  }
  .subtitle {
    text-align: center;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
  }
  .TurnoRecepcionadoLabo-btnSalir {
    height: 50px;
    width: 200px;
    background: var(--color-primary);
    border: none;
    color: var(--color-white);
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 150%;
    border-radius: 12px;
    cursor: pointer;
    position: absolute;
    bottom: 250px;
  }

  @media (max-height: 800px) {
    .TurnoRecepcionadoLabo-btnSalir {
      bottom: 230px;
    }
  }
`;

export const TurnosRecepcionadosLaboBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  @media (max-height: 800px) {
    gap: 12px;
  }
`;

export const ContainerCardBlue = styled.div`
  width: 337px;
  padding: 26px 0;
  background: var(--color-latex10);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 12px;

  span {
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    color: var(--color-white);
  }
  .container-text {
    width: 90%;
    height: max-content;
    text-align: center;
  }
  .bold {
    font-weight: bold;
  }
`;
